<template>
  <div class="col-xl-6">
    <div class="card">
      <div class="card-body">
        <h4 class="header-title mb-4">Tabs Vertical Left</h4>

        <div class="row">
          <div class="col-sm-3">
            <div
              class="nav flex-column nav-pills nav-pills-tab"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link active show mb-1"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                href="#v-pills-home"
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true"
              >
                Home</a
              >
              <a
                class="nav-link mb-1"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                href="#v-pills-profile"
                role="tab"
                aria-controls="v-pills-profile"
                aria-selected="false"
              >
                Profile</a
              >
              <a
                class="nav-link mb-1"
                id="v-pills-messages-tab"
                data-bs-toggle="pill"
                href="#v-pills-messages"
                role="tab"
                aria-controls="v-pills-messages"
                aria-selected="false"
              >
                Messages</a
              >
              <a
                class="nav-link mb-1"
                id="v-pills-settings-tab"
                data-bs-toggle="pill"
                href="#v-pills-settings"
                role="tab"
                aria-controls="v-pills-settings"
                aria-selected="false"
              >
                Settings</a
              >
            </div>
          </div>
          <!-- end col-->
          <div class="col-sm-9">
            <div class="tab-content">
              <div
                class="tab-pane fade active show"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <p>
                  Lorem ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups.
                </p>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              >
                <p>
                  Lorem ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups.Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. qui.
                </p>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-messages"
                role="tabpanel"
                aria-labelledby="v-pills-messages-tab"
              >
                <p>
                  Lorem ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups.Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups.
                </p>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-settings"
                role="tabpanel"
                aria-labelledby="v-pills-settings-tab"
              >
                <p>
                  Lorem ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups. Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups.Lorem
                  ipsum is placeholder text commonly used in the graphic, print, and
                  publishing industries for previewing layouts and visual mockups.
                </p>
              </div>
            </div>
          </div>
          <!-- end col-->
        </div>
        <!-- end row-->
      </div>
    </div>
    <!-- end card-->
  </div>
</template>
